import { memo } from 'react';
import { CardData } from '../../../../../types';

interface ColorPickerProps {
    cardNum: 1 | 2;
    label: string;
    field: keyof CardData;
    targetIdSuffix: string;
    value: string;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: string) => void;
}

export const ColorPicker = memo(({
    cardNum,
    label,
    field,
    targetIdSuffix,
    value,
    disabled,
    onChange,
}: ColorPickerProps) => {
    const handleMouseEnter = () => {
        document.getElementById(`card-${cardNum}-${targetIdSuffix}`)?.classList.add('input-highlight-border');
    };

    const handleMouseLeave = () => {
        document.getElementById(`card-${cardNum}-${targetIdSuffix}`)?.classList.remove('input-highlight-border');
    };

    return (
        <label
            className="color-picker-pill"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <p>{label}</p>
            <input
                id={`card-${cardNum}-${String(field)}`}
                type="color"
                value={value}
                onChange={(e) => onChange(cardNum, field, e.target.value)}
                disabled={disabled}
            />
        </label>
    );
});
